import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import { useTranslation } from 'react-i18next';
import es from 'date-fns/locale/es';
import pt from 'date-fns/locale/pt';
import enUS from 'date-fns/locale/en-US';
import 'react-datepicker/dist/react-datepicker.css';
import './DateRangePicker.css';

// Register locales
registerLocale('es', es);
registerLocale('pt', pt);
registerLocale('en', enUS);

const DateRangePicker = ({ startDate, endDate, onChange }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="date-range-picker">
      <div className="date-field">
        <label>{t('common.from')}</label>
        <DatePicker
          selected={startDate ? new Date(startDate) : null}
          onChange={(date) => onChange('startDate', date)}
          selectsStart
          startDate={startDate ? new Date(startDate) : null}
          endDate={endDate ? new Date(endDate) : null}
          locale={i18n.language}
          dateFormat="dd/MM/yyyy"
          className="date-input"
          placeholderText={t('common.selectDate')}
          maxDate={new Date()}
        />
      </div>
      <div className="date-field">
        <label>{t('common.to')}</label>
        <DatePicker
          selected={endDate ? new Date(endDate) : null}
          onChange={(date) => onChange('endDate', date)}
          selectsEnd
          startDate={startDate ? new Date(startDate) : null}
          endDate={endDate ? new Date(endDate) : null}
          minDate={startDate ? new Date(startDate) : null}
          maxDate={new Date()}
          locale={i18n.language}
          dateFormat="dd/MM/yyyy"
          className="date-input"
          placeholderText={t('common.selectDate')}
        />
      </div>
    </div>
  );
};

export default DateRangePicker;
